module.exports = __webpack_public_path__ + "img/help_authentication_hf@3x.a857d480.png";